import React from "react";
import classes from "./BannerCard.module.css";
import { bannerImg } from "../../constant";
import Popover from "../Popovers";
import { Trash } from "../../constant";
const BannerCard = ({ menus=[],img}) => {
  
  return (
    <div className={classes.wrapper}>
      <figure className={classes.bannerImage}>
        <img className={"img-fluid"} src={img} alt="banner img" />
      </figure>
      <span>
        <Popover items={menus} />
      </span>
    </div>
  );
};

export default BannerCard;
